"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _HostPresentationControl = require("./HostPresentationControl");
Object.keys(_HostPresentationControl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _HostPresentationControl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _HostPresentationControl[key];
    }
  });
});